var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 386.05 452.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#307cc0;stroke:#231f20;stroke-miterlimit:10;stroke-width:8px;}.cls-2{fill:#233870;}.cls-3{fill:#fff;opacity:0.69;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EGG4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M621.09,446.61c5.24,78.95-14.76,132.18-47.87,166C541.53,645.05,508.15,662.41,458.1,668c-98.68,11-213.51-51.11-214.23-190.68-.65-128.16,86.4-251.68,185.71-252.46C528.61,224.08,614.13,341.63,621.09,446.61Z",
    transform: "translate(-239.87 -220.86)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M600.53,373.11s38.26,98.45,10.57,174.8c-21.29,58.72-52.93,91.9-116.92,112.31-53.28,17-118.11,5.41-168.39-27.35-56.26-36.65-68.9-89.08-68.9-89.08S335,555.28,388.24,548.9c28.62-3.43,64.08-6.81,102.3-32.37,39.17-26.2,58.9-50.37,73.09-70.86C596.32,398.46,600.53,373.11,600.53,373.11Z",
    transform: "translate(-239.87 -220.86)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M368.7,313.84c.88,13.36,9.28,25.24,22.38,24.37s25.93-14.15,25.05-27.52-7.46-23.8-20.56-22.93S367.81,300.48,368.7,313.84Z",
    transform: "translate(-239.87 -220.86)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M409.16,548.9c-16.8,51.23-2.74,89.64,60.4,94.69,31.75,2.53,81.76-23.18,98-43.79,19.83-25.11,36.65-60.77,20-91.14-23.53-43.06-61.39-51.19-78.7-52.36C470.35,453.7,426.4,496.32,409.16,548.9Z",
    transform: "translate(-239.87 -220.86)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M384.57,397C386,419,361.18,433.63,339.12,435.1s-33.52-19.38-35-41.44,15.8-32.52,37.86-34A40,40,0,0,1,384.57,397Z",
    transform: "translate(-239.87 -220.86)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ec5ef666e0795d69606f2c046f9c3ae9.svg";
export { ForwardRef as ReactComponent };